import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from '@emotion/styled';
import React from 'react';
import { getIconSize } from "../utils";
var StyledSvgIcon = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return getIconSize(size);
}, function (_ref2) {
  var size = _ref2.size;
  return getIconSize(size);
});
export var SvgCountryFlagIcon = function SvgCountryFlagIcon(_ref3) {
  var ariaLabel = _ref3['aria-label'],
    children = _ref3.children,
    size = _ref3.size;
  return /*#__PURE__*/React.createElement(StyledSvgIcon, {
    "aria-hidden": ariaLabel ? undefined : true,
    "aria-label": ariaLabel,
    role: "img",
    size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, children);
};